import { render, staticRenderFns } from "./RedemptionSubmit.vue?vue&type=template&id=45771037&scoped=true"
import script from "./RedemptionSubmit.vue?vue&type=script&lang=js"
export * from "./RedemptionSubmit.vue?vue&type=script&lang=js"
import style0 from "./RedemptionSubmit.vue?vue&type=style&index=0&id=45771037&scoped=true&lang=scss"
import style1 from "./RedemptionSubmit.vue?vue&type=style&index=1&id=45771037&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45771037",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45771037')) {
      api.createRecord('45771037', component.options)
    } else {
      api.reload('45771037', component.options)
    }
    module.hot.accept("./RedemptionSubmit.vue?vue&type=template&id=45771037&scoped=true", function () {
      api.rerender('45771037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/RedemptionSubmit.vue"
export default component.exports